<template>
  <TemplateView>
    <TemplatePage :loading="loading">
      <div v-if="guest_periodReport__show.data" class="container">
        <StatisticProjectReportsBlankPDF
          :project="project"
          :date="date"
          :employees="guest_periodReport__show.data['reports_data']['employees']"
          :total_works="guest_periodReport__show.data['reports_data']['work_types']"
          :total_extras="guest_periodReport__show.data['reports_data']['extras']"
          :general="guest_periodReport__show.data.general_note"
          formed
          ref="pdf"
          :sign-data="signData"
          :images="images"
          :images-count="images_count"
          :key="images_count.key + '_' + $route.fullPath"
        />
        <v-sheet
          v-if="pdfGenReady"
          width="100%" max-width="800"
          class="mx-auto mt-5 mb-10 text-center"
          color="transparent"
        >
          <StatisticProjectReportsSignAddModal @signData="onSignData"/>
        </v-sheet>
      </div>
    </TemplatePage>
  </TemplateView>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'
import TemplateView from "../../../components/templates/TemplateView";
import TemplatePage from "../../../components/templates/TemplatePage";
import StatisticProjectReportsSignAddModal
  from "../../../components/timeControl/reports/StatisticProjectReportsSignAddModal";
import StatisticProjectReportsBlankPDF
  from "../../../components/timeControl/reports/blank/pdf/StatisticProjectReportsBlankPDF";
import {PDFDocument} from 'pdf-lib'

export default {
  name: "timeControlShowReportsViewSign",
  components: {
    StatisticProjectReportsBlankPDF,
    StatisticProjectReportsSignAddModal,
    TemplatePage,
    TemplateView
  },
  data: () => ({
    loading: false,
    signData: null,
    documents: [],
    images: true,
    images_count: {
      key: 0,
      value: {
        0: 1,
      }
    },
  }),
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('guest_periodReport', ['guest_periodReport__show']),
    selectedDates() {
      let obj = {}
      obj.dates = this.$getDates(
        new Date(this.guest_periodReport__show.data['period_data']['start_date']),
        new Date(this.guest_periodReport__show.data['period_data']['end_date']),
      )
      obj.weeks = []
      for (let date of obj.dates) {
        if (!obj.weeks.find((i) => i === date.getWeek())) obj.weeks.push(date.getWeek())
      }
      return obj
    },
    showSelectedWeeks() {
      let string = ''
      if (this.selectedDates.weeks) {
        for (let week in this.selectedDates.weeks) {
          if (week == 0) {
            string = string + this.selectedDates.weeks[week]
          } else {
            string = string + ', ' + this.selectedDates.weeks[week]
          }
        }
      }
      return string
    },
    project() {
      let temp = {}
      if (this.guest_periodReport__show && this.guest_periodReport__show.data) {
        temp = Object.assign({}, this.guest_periodReport__show.data['project_data'])
        temp.client = this.guest_periodReport__show.data['client_data']
        temp.manager = {
          first_name: this?.guest_periodReport__show?.data?.project_data?.manager?.first_name || '-',
          last_name: this?.guest_periodReport__show?.data?.project_data?.manager?.last_name || '',
          phone: this?.guest_periodReport__show?.data?.project_data?.manager?.phone || '-'
        }
        temp.name = temp.project_name
      }
      return temp
    },
    date() {
      let temp = ''
      if (this.guest_periodReport__show && this.guest_periodReport__show.data) {
        let start_date = this.guest_periodReport__show.data['period_data']['start_date']
        let end_date = this.guest_periodReport__show.data['period_data']['end_date']
        temp = this.$formatDate(start_date) + (end_date ? (' - ' + this.$formatDate(end_date)) : '') + (this.showSelectedWeeks ? (' Vk ' + this.showSelectedWeeks) : '')
      }
      return temp
    },
    pdfGenReady() {
      let result = []
      if (this.$refs.pdf) {
        if (this.$refs.pdf.$refs['pdf-main']) result.push(this.$refs.pdf.$refs['pdf-main']['documentReady'])
        else result.push(false)
        let employees = this.guest_periodReport__show.data
          ? this.guest_periodReport__show.data['reports_data']['employees']
          : []
        for (let key in employees) {
          if (this.$refs.pdf.$refs['pdf-' + key] && this.$refs.pdf.$refs['pdf-' + key][0])
            result.push(this.$refs.pdf.$refs['pdf-' + key][0]['documentReady'])
          else result.push(false)
        }
      }
      return result.length > 0 ? result.every((cur) => cur === true) : false
    },
    signReady() {
      return false
    }
  },
  watch: {
    pdfGenReady() {
      if (this.pdfGenReady && this.signData) {
        this.onSaveSignReport()
      }
    }
  },
  created() {
    this.onFirstLoad()
  },
  methods: {
    ...mapActions('guest_periodReport', ['ON_guest_periodReport__show', 'ON_guest_periodReport__sign']),
    ...mapActions(['uploadFile']),
    ...mapMutations(['setPdfLoader']),

    async onFirstLoad() {
      await this.ON_guest_periodReport__show(this.$route.params.hash)
        .then(() => {
          this.images = this?.guest_periodReport__show?.data?.project_data?.images_in_report || false
          for (let e in this.guest_periodReport__show.data['reports_data']['employees']) {
            // console.log('employee', this.guest_periodReport__show.data['reports_data']['employees'][e])
            for (let w in this.guest_periodReport__show.data['reports_data']['employees'][e].work_types) {
              let ddd = Object.keys(this.guest_periodReport__show.data['reports_data']['employees'][e].work_types[w].days)
              for (let dd in ddd) {
                let d = ddd[dd]
                for (let r in this.guest_periodReport__show.data['reports_data']['employees'][e].work_types[w].days[d].reports) {
                  if (this.guest_periodReport__show.data['reports_data']['employees'][e].work_types[w].days[d].reports[r].image) {
                    this.guest_periodReport__show.data['reports_data']['employees'][e].work_types[w].days[d].reports[r].image = JSON.parse(this.guest_periodReport__show.data['reports_data']['employees'][e].work_types[w].days[d].reports[r].image)
                  }
                }
              }
            }
            for (let w in this.guest_periodReport__show.data['reports_data']['employees'][e].extras) {
              let ddd = Object.keys(this.guest_periodReport__show.data['reports_data']['employees'][e].extras[w].days)
              for (let dd in ddd) {
                let d = ddd[dd]
                for (let r in this.guest_periodReport__show.data['reports_data']['employees'][e].extras[w].days[d].reports) {
                  if (this.guest_periodReport__show.data['reports_data']['employees'][e].extras[w].days[d].reports[r].image) {
                    this.guest_periodReport__show.data['reports_data']['employees'][e].extras[w].days[d].reports[r].image = JSON.parse(this.guest_periodReport__show.data['reports_data']['employees'][e].extras[w].days[d].reports[r].image)
                  }
                }
              }
            }
          }
        })
        .catch(() => this.$router.push({name: '404'}))
    },

    onSignData(data) {
      this.signData = data;
    },

    async onSaveSignReport() {
      await this.prepareAll()
      //this.loading = false
    },

    async prepareAll() {
      this.documents = []

      if (this.$refs.pdf) {
        if (this.$refs.pdf.$refs['pdf-main']) {
          this.documents.push(this.$refs.pdf.$refs['pdf-main'].getBase64())
        }
        let employees = this.guest_periodReport__show.data
          ? this.guest_periodReport__show.data['reports_data']['employees']
          : []
        for (let key in employees) {
          if (this.$refs.pdf.$refs['pdf-' + key]) {
            this.documents.push(this.$refs.pdf.$refs['pdf-' + key][0].buffer)
          }
        }
      }
      console.log('documents', this.documents)
      const mergedPdf = await PDFDocument.create()
      console.log('mergedPdf', mergedPdf)
      for (let document of this.documents) {
        console.log('document', document)
        const doc = await PDFDocument.load(document)
        console.log('document', doc)
        if (doc) {
          const copiedPages = await mergedPdf.copyPages(doc, doc.getPageIndices())
          this.numberOfAdded += 1
          copiedPages.forEach((page) => mergedPdf.addPage(page))
        }
      }
      let save = await mergedPdf.save()
      let filename =
        this.project.name + '_' +
        this.$formatDate(this.date.start_date) + '_' +
        this.$formatDate(this.date.end_date) +
        '_Vk_' + this.showSelectedWeeks +
        '_Full.pdf'
      await this.uploadPDF(save, filename)
    },
    async uploadPDF(data, fileName) {
      if (this.$refs.pdf && this.$refs.pdf.$refs['pdf-main']) {
        let total = this.$refs.pdf.$refs['pdf-main'].getBase64()
        const file = new File([data], fileName)
        let formData = new FormData()
        formData.append('file', file)
        await this.uploadFile({data: formData, guest: true}).then(res => {
          let full = res.data.url
          fetch(total)
            .then(res => res.blob())
            .then(blob => {
              const f = new File([blob], "File name", {type: "image/png"})
              this.uploadMainPDF(f, full)
            })
        })
      }
    },
    async uploadMainPDF(file, url) {
      let formData = new FormData()
      formData.append('file', file)
      await this.uploadFile({data: formData, guest: true}).then(res => {
        this.saveChanges(url, res.data.url)
      })
    },
    async saveChanges(full, total) {
      this.setPdfLoader([]);
      this.ON_guest_periodReport__sign({
        hash: this.$route.params.hash,
        data: {
          sign_photo: full,
          sign_photo_total: total,
          language_id: this.localStorage.translations.language_id
        }
      })
        .then(() => {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message: this.localStorage.translations.pages.common.notifications['izmeneniya-uspeshno-sohraneny'],
              IsError: false,
              complete: true
            },
            {root: true},
          )
          setTimeout(
            this.isLoggedIn ? this.$router.push({path: '/'}) : window.location.href = "https://proapp.fi/",
            2000
          )
        })
        .catch((err) => {
          console.log(err)
          this.$store.dispatch(
            'popup/onMessage',
            {message: this.localStorage.translations.pages.common.notifications['oshibka'], IsError: true},
            {root: true},
          )
        })
    }
  }
}
</script>

<style scoped lang="scss">
:deep() .fixedBtn {
  z-index: 10;
  position: fixed;
  bottom: 165px;
  right: 10px;
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 1fr;
  grid-gap: 4px;

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    padding: 15px 12px;
    bottom: 135px;
    right: -2px;
  }

  .v-btn {
    background-color: #277FAF !important;
    color: #F2F2F2 !important;
    border-radius: 50px !important;

    &:hover {
      background-color: white !important;
      color: #277FAF !important;
      border: 1px solid #277FAF !important;
    }
  }
}
</style>
